<template>
  <div
    v-if="sections && !topics"
    style="overflow-y: hidden; overflow-x: hidden; background-color: white"
  >
    <div v-for="section in sections" :key="section.description">
      <vetalfa-section-title
        :prop="section.description"
        :collapse="section.collapse"
        :isCollapsed="collapseAll"
      >
        <vetalfa-simple-table v-if="section.table" :table="section.table">
        </vetalfa-simple-table>
        <vetalfa-section-paragraph
          v-for="(paragraph, index) in section.paragraphs"
          :key="index + paragraph"
          :prop="paragraph"
        ></vetalfa-section-paragraph>
        <vetalfa-section-item-title
          v-for="(obj1, index) in section.objects"
          :key="index + obj1.description"
          :prop="obj1.description"
        >
          <vetalfa-simple-table v-if="obj1.table" :table="obj1.table">
          </vetalfa-simple-table>
          <vetalfa-section-item
            v-for="(obj2, index) in obj1.objects"
            :key="index + obj2.description"
            :prop="obj2.description"
            :references="obj2.references"
            :index="index"
          >
            <vetalfa-simple-table v-if="obj2.table" :table="obj2.table">
            </vetalfa-simple-table>
            <vetalfa-section-sub-item
              v-for="(obj3, index) in obj2.objects"
              :key="index + obj3.description"
              :prop="obj3.description"
              :references="obj3.references"
              :index="index"
            >
              <vetalfa-simple-table v-if="obj3.table" :table="obj3.table">
              </vetalfa-simple-table>
            </vetalfa-section-sub-item>
          </vetalfa-section-item>
        </vetalfa-section-item-title>
      </vetalfa-section-title>
    </div>
    <vetalfa-section-title
      v-if="references && references.length"
      :prop="_getLabel('REFERENCES')"
    >
      <div v-for="reference in references" :key="reference.name">
        <vetalfa-reference-card :reference="reference"></vetalfa-reference-card>
      </div>
    </vetalfa-section-title>
    <div style="height: 30px; background-color: white"></div>
  </div>
  <div
    v-else-if="sections && adminMode"
    id="vetalfa-general-tab"
    style="overflow-y: scroll; overflow-x: hidden; background-color: white"
  >
    <v-expansion-panels
      v-model="expansionPanelModel"
      accordion
      class="mt-2"
      multiple
    >
      <v-expansion-panel
        v-for="macroTopic in topicsSections"
        :key="`macro-topic-${macroTopic.text}`"
      >
        <v-expansion-panel-header class="ma-0 pa-0 pl-2 pr-3">
          <span class="vetalfa-card-title">{{ macroTopic.text }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="ma-0 pa-0 pb-5 mb-5">
          <vetalfa-sections :sections="macroTopic.sections"></vetalfa-sections>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        v-if="references && references.length"
        :prop="_getLabel('REFERENCES')"
      >
        <v-expansion-panel-header dense class="ma-0 pa-0 pl-2 pr-3">
          <span class="vetalfa-card-title">{{ _getLabel("REFERENCES") }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="ma-0 pa-0 pb-5 mb-5">
          <vetalfa-section-title
            v-if="!!internalReferences && !!internalReferences.length"
            :prop="_getLabel('INTERNAL_REFERENCES')"
          >
            <div v-for="reference in internalReferences" :key="reference.name">
              <vetalfa-reference-card
                :reference="reference"
              ></vetalfa-reference-card>
            </div>
          </vetalfa-section-title>
          <vetalfa-section-title
            v-if="!!externalReferences && !!externalReferences.length"
            :prop="_getLabel('EXTERNAL_REFERENCES')"
          >
            <div v-for="reference in externalReferences" :key="reference.name">
              <vetalfa-reference-card
                :reference="reference"
              ></vetalfa-reference-card>
            </div>
          </vetalfa-section-title>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <vetalfa-references-dialog></vetalfa-references-dialog>
    <div style="height: 1px; background-color: white"></div>
  </div>
  <div v-else id="vetalfa-general-tab" style="background-color: white">
    <v-timeline
      id="vetalfa-algorithms-timeline"
      class="ma-0 pa-0"
      align-top
      dense
    >
      <v-timeline-item
        v-for="(macroTopic, contentIndex) in topicsSections"
        :key="`macro-topic-${macroTopic.text}`"
        fill-dot
        color="white"
        small
        v-bind:class="contentIndex > 0 ? 'ma-0 pa-0 mt-5 pt-2' : 'ma-0 pa-0'"
      >
        <template v-slot:icon>
          <div
            class="vetalfa-general-tab-timeline-avatar primary vetalfa-pointer"
            @click="openContent(contentIndex)"
          >
            <p class="ma-0 pa-0 white--text text-center">
              {{ contentIndex + 1 }}
            </p>
          </div>
        </template>
        <v-row class="vetalfa-card-text ma-0 pa-0 pl-2 mt-1">
          <v-col cols="12" class="ma-0 pa-0">
            <v-row
              @click="openContent(contentIndex)"
              class="vetalfa-pointer ma-0 pa-0"
              justify="start"
            >
              <b class="ma-0 pa-0 primary--text text-left">
                {{ macroTopic.text }}
              </b>
            </v-row>
          </v-col>
          <v-col
            v-for="(section, sectionIndex) in filterMacroTopicTitles(
              macroTopic
            )"
            :key="section.text + sectionIndex"
            cols="12"
            class="ma-0 pa-0 mt-3"
          >
            <v-row
              @click="openContent(contentIndex, sectionIndex)"
              class="vetalfa-pointer ma-0 pa-0"
              justify="start"
              v-if="
                contentIndex != contentIndexRoute ||
                sectionIndex != sectionIndexRoute
              "
            >
              <span class="ma-0 pa-0 text-decoration-underline text-left">
                {{ section.text }}
              </span>
            </v-row>
            <v-row
              @click="openContent(contentIndex, sectionIndex)"
              class="vetalfa-pointer ma-0 pa-0"
              justify="start"
              v-else
            >
              <span
                class="general-tab-timeline-chip text-decoration-underline text-left primary--text"
              >
                {{ section.text }}
              </span>
            </v-row>
          </v-col>
        </v-row>
      </v-timeline-item>
      <v-timeline-item
        fill-dot
        outlined
        color="white"
        class="ma-0 pa-0 mt-5 pt-2"
        v-if="!!references && !!references.length && !isItemContentRoute"
        small
      >
        <template v-slot:icon>
          <div
            class="vetalfa-general-tab-timeline-avatar primary vetalfa-pointer"
            @click="setClickedReferences(references)"
          >
            <p class="ma-0 pa-0 white--text text-center">
              {{ topicsSections.length + 1 }}
            </p>
          </div>
        </template>
        <v-row class="vetalfa-card-text ma-0 pa-0 pl-2 mt-1">
          <v-col cols="12" class="ma-0 pa-0">
            <v-row
              @click="setClickedReferences(references)"
              class="vetalfa-pointer ma-0 pa-0"
              justify="start"
            >
              <b class="ma-0 pa-0 primary--text">
                {{ _getLabel("REFERENCES") }}
              </b>
            </v-row>
          </v-col>
        </v-row>
      </v-timeline-item>
      <v-timeline-item
        fill-dot
        outlined
        color="white"
        class="ma-0 pa-0 mt-5 pt-2"
        v-if="itemId.includes('treatment')"
        small
      >
        <template v-slot:icon>
          <v-btn
            width="20"
            height="20"
            fab
            color="primary white--text"
            class="mt-1"
            @click="openDiseasesFullApproach"
          >
            <v-icon size="14" color="white">{{
              _icon("diseasesRaised")
            }}</v-icon>
          </v-btn>
        </template>
        <v-row class="vetalfa-card-text ma-0 pa-0 pl-2" align="start">
          <v-col cols="12" class="ma-0 pa-0">
            <v-row
              @click="openDiseasesFullApproach"
              class="vetalfa-pointer ma-0 pa-0"
              justify="start"
              align="center"
            >
              <b class="ma-0 pa-0 primary--text font-italic">
                {{ _getLabel("COMPLETE_APPROACH_DISEASES_TIMELINE_ITEM") }}
              </b>
              <v-icon color="primary" class="ma-0 pa-0">{{
                mdiChevronRight
              }}</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
    <div style="height: 50px; background-color: white"></div>
    <vetalfa-references-dialog></vetalfa-references-dialog>
  </div>
</template>

<style>
.v-expansion-panel-content__wrap {
  padding: 0px;
}
.v-application--is-ltr
  .v-list--dense
  .v-list-group--sub-group
  .v-list-group__header {
  padding-left: 8px !important;
}
.v-application--is-ltr
  .v-list-group--no-action.v-list-group--sub-group
  > .v-list-group__items
  > .v-list-item {
  padding-left: 60px !important;
}
.vetalfa-general-tab-timeline-avatar {
  height: 14px;
  width: 14px;
  border-radius: 7px;
  font-size: 10px;
  line-height: 14px;
}
.general-tab-timeline-chip {
  background-color: rgb(0, 114, 138, 0.14);
  line-height: 14px;
  border-radius: 16px;
  padding: 8px 8px 8px 8px;
  margin-left: -8px;
  margin-right: 8px;
  white-space: normal !important;
  width: auto !important;
}
</style>

<script>
import { mapMutations, mapActions } from "vuex";
import ReferencesDialog from "@/components/ReferencesDialog.vue";
import { mdiChevronLeft, mdiChevronRight, mdiChevronUp } from "@mdi/js";
export default {
  name: "GeneralTab",
  components: {
    "vetalfa-references-dialog": ReferencesDialog,
  },
  watch: {
    sections() {
      if (process.env.VUE_APP_ENV == "production") {
        this.expansionPanelModel = [];
      }
    },
  },
  computed: {
    isItemContentRoute() {
      return this.$route.path.includes("/content");
    },
    sectionIndexRoute() {
      return this.$route.params.sectionIndex;
    },
    contentIndexRoute() {
      return this.$route.params.contentIndex;
    },
    topicsSections() {
      let macroTopics = [];
      if (this.topics) {
        let macroTopicIndex = -1;
        for (let section of this.sections) {
          if (section.style == 0) {
            macroTopicIndex++;
            macroTopics.push({ ...section, sections: [] });
          } else {
            macroTopics[macroTopicIndex].sections.push(section);
          }
        }
      }
      return macroTopics;
    },

    internalReferences() {
      return this.references.filter((reference) => {
        return !!reference.type && reference.type == 1;
      });
    },
    externalReferences() {
      return this.references.filter((reference) => {
        return !reference.type || reference.type == 0;
      });
    },
  },
  methods: {
    ...mapMutations("general", ["setGoToSection"]),
    ...mapMutations("topics", ["setClickedReferences", "setItemContent"]),
    ...mapActions("general", ["routePathRedirect"]),
    ...mapActions("topics", ["openDiseasesFullApproach"]),
    filterMacroTopicTitles(macroTopic) {
      if (macroTopic.text.includes(this._getLabel("TUTOR"))) return [];
      return macroTopic.sections.filter((s) => {
        return s.style == 1;
      });
    },
    isDoseReference(item) {
      return (
        !!item.references &&
        item.references.length == 1 &&
        !!item.references[0].dose
      );
    },
    getItemIndex(sections, sectionIndex) {
      try {
        return [3, 4].includes(sections[sectionIndex - 1].style) &&
          !this.isDoseReference(sections[sectionIndex - 1])
          ? 1
          : 0;
      } catch (error) {
        return 0;
      }
    },
    openContent(contentIndex, sectionIndex = 0) {
      if (!this.isItemContentRoute) {
        this.setItemContent(null);
        const path = `/item/${this.itemId}/content/${contentIndex}/section/${sectionIndex}`;
        this.routePathRedirect({ path });
      } else {
        this.$emit("openContent", { contentIndex, sectionIndex });
      }
    },
  },
  props: {
    sections: {
      type: Array,
    },
    references: {
      type: Array,
      default: null,
    },
    collapseAll: {
      type: Boolean,
      default: false,
    },
    topics: {
      type: Boolean,
      default: false,
    },
    itemName: {
      type: String,
      default: "",
    },
    itemId: {
      type: String,
      default: "",
    },
    topicName: {
      type: String,
      default: "",
    },
    adminMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mdiChevronLeft,
      mdiChevronRight,
      mdiChevronUp,
      expansionPanelModel: [],
      totalHeight: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(
        function () {
          const root = document.querySelector(":root");
          this.totalHeight = document.getElementById(
            "vetalfa-general-tab"
          ).offsetHeight;
          root.style.setProperty(
            "--pseudo-timeline-height",
            `${this.totalHeight - (this.isItemContentRoute ? 90 : 70)}px`
          );
          root.style.setProperty("--pseudo-timeline-top", "10px");
        }.bind(this),
        100
      );
    });
  },
};
</script>